// extracted by mini-css-extract-plugin
module.exports = {"supportTrayImgWrapper":"SupportTraySelector_supportTrayImgWrapper__8lM_4"};